import React, {useEffect, useState, useCallback} from "react";
import axios from "axios";
import DataTables from "./components/TransactionsTable";

function TicketsTransactions() {
    const [tabs, setTabs] = useState(0);
    const [count, setCount] = useState(0);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [sortField, setSortField] = useState("date");
    const [orderBy, setOrderBy] = useState(false);
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [errorMsg] = useState("");
    const [deleteGroupsIds, setDeleteGroupsIds] = useState([]);
    const [filterInputs, setFilterInputs] = useState({
        ticketNumber: "",
        startDate: "",
        endDate: ""
    })

    const url = {
        0: `agent/getAllTransactions?typeId=0`,
        1: 'agent/getAllTransactions?typeId=1',
        2: 'agent/getAllTransactions?typeId=2'
    }

    const onGroups = (controller) => {
        axios
            .get(`${url[tabs]}`, {
                params: {
                    skip, take, sortField, orderBy,
                    ...(filterInputs.ticketNumber && {ticketNumber: filterInputs.ticketNumber}),
                    ...(filterInputs.startDate && {startDate: `${filterInputs.startDate}`}),
                    ...(filterInputs.endDate && {endDate: `${filterInputs.endDate}`})
                },
                signal: controller.signal
            })
            .then(({data: {data, count}}) => {
                setIsLoading(false);
                setGroups(data);
                setIsError(false);
                setCount(count)
            })
            .catch(() => {
                setIsLoading(false);
                setGroups([]);
                setIsError(true);
            });
    };

    const filterInputsUpdate = (e) => {
        e.persist()
        setFilterInputs(prevState => ({
            ...prevState,
            [e.target?.name]: e.target?.value
        }))
    }

    const resetFilter = useCallback(() => {
        setFilterInputs({
            ticketNumber: "",
            startDate: "",
            endDate: ""
        })
    }, [])

    useEffect(() => {
        const controller = new AbortController();
        onGroups(controller);

        return () => {
            controller.abort()
        }

    }, [tabs, sortField, orderBy, skip, take, filterInputs]);

    return (
        <>
            <DataTables
                groups={groups}
                tabs={tabs}
                setTabs={setTabs}
                count={count}
                isLoading={isLoading}
                isError={isError}
                errorMsg={errorMsg}
                setDeleteGroupsIds={setDeleteGroupsIds}
                deleteGroupsIds={deleteGroupsIds}
                skip={skip}
                setSkip={setSkip}
                take={take}
                setTake={setTake}
                sortField={sortField}
                setSortField={setSortField}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
                filterInputs={filterInputs}
                filterInputsUpdate={filterInputsUpdate}
                resetFilter={resetFilter}
                setFilterInputs={setFilterInputs}
            />
        </>
    );
}

export default TicketsTransactions;
